import { useCallback } from 'react';
import { GridActionsCellItem } from '@mui/x-data-grid-pro';
import EditIcon from '@mui/icons-material/Edit';
import { Box } from '@mui/material';
import { TableStatusIcons } from '../../components/table/TableStatusIcons';
import LocalDate from '../../components/LocalDate.jsx';

export function useColumns() {
  const buildColumns = useCallback((type, onAdjust) => {
    const unique =
      type === 'L'
        ? [
            {
              field: 'quality',
              headerName: 'Lime Quality',
              type: 'number',
              headerAlign: 'left',
              align: 'left',
              flex: 0.75,
              valueGetter: ({ row }) => row.prescription?.quality,
            },
            {
              field: 'referenceQuality',
              headerName: 'Ref Lime Quality',
              type: 'number',
              headerAlign: 'left',
              align: 'left',
              flex: 0.75,
              valueGetter: ({ row }) => row.prescription?.referenceQuality,
            },
          ]
        : [
            {
              field: 'yearsToCritical',
              headerName: 'Yrs to Critical',
              type: 'number',
              headerAlign: 'left',
              align: 'left',
              flex: 0.75,
              valueGetter: ({ row }) => row.prescription?.yearsToCritical,
            },
            {
              field: 'numberOfCroppingYears',
              headerName: 'Num Cropping Years',
              type: 'number',
              headerAlign: 'left',
              align: 'left',
              flex: 0.75,
              valueGetter: ({ row }) => row.prescription?.numberOfCroppingYears,
            },
            {
              field: 'otherApplications',
              headerName: `Other ${type} App lbs/ac`,
              type: 'number',
              headerAlign: 'left',
              align: 'left',
              flex: 0.75,
              valueGetter: ({ row }) => row.prescription?.otherApplications,
            },
          ];

    const productColumns =
      type === 'L'
        ? []
        : [
            {
              field: 'product',
              headerName: 'Product',
              headerAlign: 'left',
              align: 'left',
              flex: 0.75,
              valueGetter: ({ row }) => row.prescription?.product,
            },
          ];

    return [
      {
        field: 'plannedCrop',
        headerName: 'Planned Crop',
        flex: 0.75,
      },
      {
        field: 'tillageType',
        headerName: 'Tillage Type',
        flex: 1,
      },
      ...unique,
      {
        field: 'min',
        headerName: 'Min lbs/acre',
        type: 'number',
        headerAlign: 'left',
        align: 'left',
        flex: 0.75,
        valueGetter: ({ row }) => row.prescription?.stats?.min,
        valueFormatter: ({ value }) =>
          value?.toLocaleString('en-US', { maximumFractionDigits: 0 }),
      },
      {
        field: 'max',
        headerName: 'Max lbs/acre',
        type: 'number',
        headerAlign: 'left',
        align: 'left',
        flex: 0.75,
        valueGetter: ({ row }) => row.prescription?.stats?.max,
        valueFormatter: ({ value }) =>
          value?.toLocaleString('en-US', { maximumFractionDigits: 0 }),
      },
      {
        field: 'avg',
        headerName: 'Product Avg lbs/acre',
        type: 'number',
        headerAlign: 'left',
        align: 'left',
        flex: 0.75,
        valueGetter: ({ row }) => row.prescription?.stats?.avg,
        valueFormatter: ({ value }) =>
          value?.toLocaleString('en-US', { maximumFractionDigits: 0 }),
      },
      ...productColumns,
      {
        field: 'createdAt',
        headerName: 'Created',
        type: 'date',
        flex: 1,
        valueGetter: ({ row }) => row.prescription?.createdAt,
      },
      {
        field: 'soilDate',
        headerName: 'Reference Soil Date',
        type: 'date',
        flex: 1,
        renderCell: ({ row }) => (
          <LocalDate timeZone="UTC" value={row.prescription?.soilDate} />
        ),
      },
      {
        field: 'status',
        headerName: 'Status',
        width: 70,
        renderCell: ({ row }) => (
          <Box sx={{ height: '100%', display: 'flex', alignItems: 'center' }}>
            <TableStatusIcons
              status={row.prescription?.status}
              statusDetails={row.prescription?.statusDetails}
            />
          </Box>
        ),
      },
      {
        field: 'actions',
        type: 'actions',
        headerName: 'Adjust',
        width: 70,
        getActions: ({ row }) => [
          <GridActionsCellItem
            data-testid={`adjust-${row.prescription?.id}`}
            icon={<EditIcon />}
            label="Adjust"
            disabled={!row.prescription?.stats?.distribution}
            onClick={() => onAdjust(row)}
          />,
        ],
      },
    ];
  }, []);

  return { buildColumns };
}
